import React from 'react';
import { Outlet } from 'react-router-dom';
import AccessDeniedCard from '../../../components/AccessDeniedCard';
import { usePermissions } from '../../../hooks/usePermissions';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_BULK_UPLOAD, READ_PURCHASE_REGISTER, READ_SALE_REGISTER } from '../../../constants/eInvoicePermissions';
import { BULK_UPLOAD_MODULE_KEY } from '../../settings/constants/roleModules';

export default function RegisterBulkUploadAccessLayout() {
  const { loading, hasEInvoicePermission } = usePermissions();
  const title = useRoleModuleLabel(BULK_UPLOAD_MODULE_KEY);

  if (loading) {
    return null;
  }

  const canReadResource = hasEInvoicePermission(READ_SALE_REGISTER) || hasEInvoicePermission(READ_PURCHASE_REGISTER);
  const isAllowed = hasEInvoicePermission(READ_BULK_UPLOAD) && canReadResource;

  if (!isAllowed) {
    return <AccessDeniedCard title={title} />;
  }

  return <Outlet />;
}
